import {
  CheckoutOrder,
  RemoteResult,
  CheckoutRequest,
  LoadState,
} from "mangdto"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import BaseLogic from "../base_logic"

export default class BezahlungWeiterleitenLogic extends BaseLogic {
  weiterleitenLoadState: LoadState = LoadState.Idle

  init(id: string) {
    var request = new CheckoutRequest()
    request.id = id
    request.checkoutMode = 1

    Poster.postUser<RemoteResult<CheckoutOrder>>(
      RestPaths.paymentPaypalCheckout,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.weiterleitenLoadState = LoadState.Completed
          window.location.href =
            "https://www.sandbox.paypal.com/checkoutnow?token=" +
            response.data.payload.orderId
        } else {
          this.weiterleitenLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.weiterleitenLoadState = LoadState.Error
      })
  }
}
